import { isEmpty } from "lodash"

const usersReducerDefaultState = {
  profileDialogOpen: false,
  createUserDialogOpen: false,
  createClientDialogOpen: false,
  createProducerDialogOpen: false,
  createCalendarDialogOpen: false,
  editUser: {},
  updatingUser: false,
  createdClient: null,
  createdProducer: null,
  setModal: null,
  crewModal: [],
  userDefaultFilters: null,
}

export default (state = usersReducerDefaultState, action) => {
  switch (action.type) {
    case "USER::SET::CREW_MODAL":
      return {
        ...state,
        crewModal: action.payload,
      }
    case "USER::SET::BOOK_MODAL":
      return {
        ...state,
        setModal: action.payload,
      }
    case "USER::SET::USER_DEFAULT_FILTERS":
      return {
        ...state,
        userDefaultFilters: action.data,
      }
    case "USER::UPDATING_USER":
      return {
        ...state,
        updatingUser: action.updatingUser,
      }
    case "USER::UPDATE":
      return {
        ...state,
        editUser: {
          ...state.editUser,
          ...action.updates,
        },
      }
    case "USER::SET":
      return {
        ...state,
        editUser: action.data,
      }
    case "USER::SET_CREATED_CLIENT":
      return {
        ...state,
        createdClient: {
          id: action.createdClient["id"],
          full_name: `${action.createdClient["first_name"]} ${
            action.createdClient["last_name"]
          }`,
        },
      }
    case "USER::SET_CREATED_PRODUCER":
      return {
        ...state,
        createdProducer: {
          id: action.createdProducer["id"],
          full_name: `${action.createdProducer["first_name"]} ${
            action.createdProducer["last_name"]
          }`,
        },
      }
    case "USER::TOGGLE_PROFILE_DIALOG":
      return {
        ...state,
        profileDialogOpen: action.profileDialogOpen,
        editUser: action.editUser === undefined ? {} : action.editUser,
      }
    case "USER::RATING::SET":
      if (!isEmpty(state.editUser)) {
        let ratings = state.editUser.ratings
        if (action.rating.hasOwnProperty("id")) {
          ratings = ratings.map(r => {
            if (r.id === action.rating.id) {
              const newId = action.rating.newId
              delete action.rating.newId
              r = {
                ...r,
                ...action.rating,
                id: newId,
              }
            }
            return r
          })
        } else {
          ratings = [...ratings, action.rating]
        }
        return {
          ...state,
          editUser: {
            ...state.editUser,
            ratings,
            avg_rating: action.avgRating,
          },
        }
      } else {
        return {
          ...state,
        }
      }
    case "USER::TOGGLE_CREATE_USER_DIALOG":
      return {
        ...state,
        createUserDialogOpen: action.createUserDialogOpen,
        editUser:
          action.editUser === undefined ? state.editUser : action.editUser,
      }
    case "USER::TOGGLE_CREATE_CLIENT_DIALOG":
      return {
        ...state,
        createClientDialogOpen: action.createClientDialogOpen,
        editUser:
          action.editUser === undefined ? state.editUser : action.editUser,
      }
    case "USER::TOGGLE_CREATE_PRODUCER_DIALOG":
      return {
        ...state,
        createProducerDialogOpen: action.createProducerDialogOpen,
        editUser:
          action.editUser === undefined ? state.editUser : action.editUser,
      }
    case "USER::TOGGLE_CREATE_CALENDAR_DIALOG":
      return {
        ...state,
        createCalendarDialogOpen: action.createCalendarDialogOpen,
        createCalendarDialogProps: action.createCalendarDialogProps,
      }
    default:
      return state
  }
}
